import React, { Component } from 'react'
import { Text, View, StyleSheet } from 'react-native'
import { GoalCardWithFullDescription } from '../../Bookings/components';
import { mappedTitles, mappedIcons } from '../../WorkoutGoalAssistant/utils';
import { workoutProgramWithDescriptions } from 'fitbeat.gym-core';
import { ProgramType, IEnabledFeatures } from 'fitbeat.models';
import { translate } from 'react-i18next';
import Theme from '../../theme';
import { UserDataConsumer } from '../../utils';
import { connect } from 'react-redux';
import { toggleWorkoutProgramSelectModalVisible } from '../redux/uiActions';
import { scaleText, defaultScale } from '../../utils/scaling';
import { enabledFeaturesSelector } from '../../auth';
import { IAppStore } from '../../HomeWorkouts';
import { TranslateProp } from '../../common-types';

interface IProps {
    t: TranslateProp;
    longTermGoal?: string;
    enabledFeatures: IEnabledFeatures;
    toggleWorkoutProgramSelectModalVisible: () => void;
}

class GoalCardWithNutritionDescriptionComponent extends Component<IProps> {

    public showWorkoutProgramSelectModal = () => {
        this.props.toggleWorkoutProgramSelectModalVisible();
    }

    public render() {
        const { longTermGoal, enabledFeatures } = this.props;
        const userLongTermGoal = !longTermGoal || longTermGoal === 'NotSet' ?
        ProgramType.GetStrongAndFitGoal : longTermGoal;
        let title;
        let icon;
        const workoutType = workoutProgramWithDescriptions(enabledFeatures)
            .filter(({ programType }) => programType !== ProgramType.NotSet)
            .find(({ programType }) => {
                title = mappedTitles[programType];
                icon = mappedIcons[programType]({}, Theme.BLACK);
                return programType === userLongTermGoal;
            });

        if (!workoutType) {
            return null;
        }

        return (
            <GoalCardWithFullDescription
                onPress={this.showWorkoutProgramSelectModal}
                withArrow={false}
                description={workoutType.nutritionDescription}
                isActive={false}
                key={workoutType.programType}
                title={title}
                icon={icon}
                subtitle='LONG TERM FITNESS GOAL'
                containerStyle={styles.cardContainer}
                headingTextStyle={{ ...Theme.textStyle.bodyCopyBold, color: Theme.DARK_CHARCOAL,
                    fontSize: scaleText(14) }}
                subtitleStyle={{ ...Theme.textStyle.bodyCopyMed, color: Theme.DARK_CHARCOAL, fontSize: scaleText(11),
                    fontFamily: Theme.Weight500 }}
                descriptionTextStyle={{ ...Theme.textStyle.small, fontSize: scaleText(13), color: Theme.DARK_CHARCOAL,
                    paddingTop: defaultScale(20) }}
            />
        )
    }
}
const styles = StyleSheet.create({
    cardContainer: {
        borderWidth: 0,
        backgroundColor: Theme.WHITE,
        borderTopWidth: 1,
        borderTopColor: Theme.GREY_LIGHT,
        paddingTop: defaultScale(20),
    },
});

const mapStateToProps = (state: IAppStore) => ({
    enabledFeatures: enabledFeaturesSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    toggleWorkoutProgramSelectModalVisible: () => dispatch(toggleWorkoutProgramSelectModalVisible(true)),
});

const GoalCardWithNutritionDescription = UserDataConsumer(
    connect(mapStateToProps, mapDispatchToProps)(GoalCardWithNutritionDescriptionComponent),
);

export default translate(['nutrition'], { wait: true })(GoalCardWithNutritionDescription);
